import { DropdownOption } from '@modusign/react-signing/types';
import uniq from 'lodash/uniq';

export type DROPDOWN_FIELD_OPTION_ERROR = 'NO_OPTION' | 'TOO_MANY_OPTION' | 'DUPLICATED_OPTION';

export const MAX_OPTION_COUNT = 100;

export function validateDropdownFieldOptions(
  options: DropdownOption[]
): DROPDOWN_FIELD_OPTION_ERROR | null {
  if (options.length === 0) {
    return 'NO_OPTION';
  }
  const isDuplicated = uniq(options.map((option) => option.value)).length !== options.length;

  if (isDuplicated) {
    return 'DUPLICATED_OPTION';
  }

  if (options.length > MAX_OPTION_COUNT) {
    return 'TOO_MANY_OPTION';
  }

  return null;
}
